import React, { useEffect, useState } from 'react';
import { Button, Box, Text, Link } from 'theme-ui';

const styles = {
  container: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    'z-index': 100,
  },
  box: {
    width: '90%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    alignItems: 'center',
    justifyContent: [null, null, 'flex-start', 'space-between'],
    background: '#4B5667',
    borderRadius: '15px',
    marginBottom: '10px',
    padding: '20px 30px',
    color: '#FFFFFF',
  },
  text: {
    width: ['100%', '100%', '60%', '70%'],
  },
  linkBox: {
    display: 'flex',
    flexDirection: 'flex-row',
    alignItems: 'center',
    width: ['100%', '100%', '40%', '30%'],
    justifyContent: ['space-between', null, null, 'space-around'],
    marginLeft: [null, null, '3rem', null],
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    width: 'auto',
    '&: visited': {
      color: 'rgba(255,255,255, 0.7)',
    },
    '&:hover': {
      scale: '1.1',
      transition: 'all 300ms',
    },
  },
  button: {
    color: '#4B5667',
    paddingTop: ['0.2rem', '0.5rem', '0.8rem', '0.8rem'],
    paddingBottom: ['0.2rem', '0.5rem', '0.8rem', '0.8rem'],
    paddingLeft: ['0.5rem', '1rem', '1.5rem', '2rem'],
    paddingRight: ['0.5rem', '1rem', '1.5rem', '2rem'],
    width: 'auto',
    fontSize: '1rem',
  },
};

const CookieBanner = () => {
  const [accepted, setAccepted] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem('accepted')) {
      setAccepted(false);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('accepted', 'true');
    setAccepted(true);
  };

  return (
    !accepted && (
      <Box sx={styles.container}>
        <Box sx={styles.box}>
          <Text sx={styles.text}>
          Этот сайт использует файлы cookie для улучшения вашего пользовательского опыта, анализа трафика и персонализации контента. 
          Продолжая пользоваться нашим сайтом, вы соглашаетесь с использованием файлов cookie. 
          </Text>
          <Box sx={styles.linkBox}>
            <Link href='/privacy' sx={styles.link}>
            Условия
            </Link>
            <Button sx={styles.button} variant='icon' onClick={accept}>
              Принять
            </Button>
          </Box>
        </Box>
      </Box>
    )
  );
};

export default CookieBanner;
